import {createContext, useState} from "react";
import {v4 as uuid} from "uuid";

const DataFlowContext = createContext();
function DataFlowProvider({children}) {
    const [comment, setComment] = useState({});

    const [nodeValue, setNodeValue] = useState({
        variables: [
            {
                id: uuid(),
                value: 'PROFILE_NAME',
                label: 'PROFILE_NAME',
                data: "",
                type: 'disabled',
            },
            {
                id: uuid(),
                value: 'PROFILE_ID',
                label: 'PROFILE_ID',
                data: "",
                type: 'disabled',
            }
        ]
    })

    const onCreateNewVariable = (variableName) => {
        const variableExist = nodeValue.variables.find(variable => variable.value === variableName);
        if (variableExist) return;
        const newVariable = {
            id: uuid(),
            value: variableName,
            label: variableName,
            data: "",
            name: ""
        }
        setNodeValue({
            variables: [...nodeValue.variables, newVariable]
        })
    }

    const createNewVariables = (variables) => {
        const currentVariables = new Set();
        nodeValue.variables.forEach(item => currentVariables.add(item.value));
        variables.forEach(variable => {
            if (currentVariables.has(variable)) return;
            const newVariable = {
                id: uuid(),
                value: variable,
                label: variable,
                data: "",
                name: ""
            }
            setNodeValue(nodeValue => {
                nodeValue.variables.push(newVariable)
                return nodeValue
            })
        })
        return;
    }

    const value = {
        comment,
        nodeValue,
        setComment,
        onCreateNewVariable,
        createNewVariables,
        setNodeValue,
    }

    return (
        <DataFlowContext.Provider value={value}>
            {children}
        </DataFlowContext.Provider>
    )
}

export {DataFlowContext, DataFlowProvider}